module.exports = __webpack_public_path__ + "static/media/call-in.20e17d4b.svg";